import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    CategoryProductListContainer as SourceCategoryProductListContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/CategoryProductList/CategoryProductList.container';

import './CategoryProductList.override.style';

/** @namespace Elganso/Component/CategoryProductList/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state)
    // TODO extend mapStateToProps
});

/** @namespace Elganso/Component/CategoryProductList/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
    // TODO extend mapDispatchToProps
});

/** @namespace Elganso/Component/CategoryProductList/Container */
export class CategoryProductListContainer extends SourceCategoryProductListContainer {
    static propTypes = {
        ...this.propTypes,
        pageSize: PropTypes.number
    };

    static defaultProps = {
        ...this.defaultProps,
        pageSize: 8 // Nº Productos por página
    };

    containerProps() {
        const {
            pageSize,
            valueColumn
        } = this.props;

        return {
            ...super.containerProps(),
            pageSize,
            valueColumn
        };
    }

    makeScrollToProduct() {
        const { isLoading } = this.props;

        const itemId = localStorage.getItem('scrollToProduct');

        if (!isLoading && itemId !== null && itemId !== 'null') {
            const items = document.getElementsByClassName(itemId);

            if (items[0] !== undefined) {
                setTimeout(() => {
                    if (items[0] !== undefined) {
                        items[0].scrollIntoView({ block: 'center' });
                    }
                    localStorage.setItem('scrollToProduct', null);
                }, 2000, items);
            }
        }
    }

    requestProductList(options) {
        const { requestProductList, pageSize, pages } = this.props;
        const { currentPage, filter: { categoryIds, customFilters = {} } } = options.args;
        const opciones = options;
        opciones.args.pageSize = pageSize;

        const catId = localStorage.getItem('lastCategoryId');
        const clickResetButton = localStorage.getItem('clickResetButton');

        if (parseInt(catId, 10) === categoryIds && Object.keys(customFilters).length === 0 && !clickResetButton) {
            if (pages[currentPage]) {
                this.makeScrollToProduct();
                // Si esta la pagina ya cargada no volvemos a hacer peticion
                return;
            }
        } else {
            localStorage.setItem('lastCategoryId', categoryIds);
        }

        if (clickResetButton) {
            localStorage.setItem('clickResetButton', false);
        }

        requestProductList({ ...opciones, isPlp: true });
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryProductListContainer);
